export default __webpack_public_path__ + "static/media/xk.48269c0b.svg";